import { BrandColorTokens } from './presets';
import { resolveBrandConfig } from './resolve-brand-config';

const DARK_SURFACE_OVERRIDES: Partial<BrandColorTokens> = {
  background: '222.2 84% 4.9%',
  foreground: '210 40% 98%',
  card: '222.2 84% 4.9%',
  cardForeground: '210 40% 98%',
  secondary: '217.2 32.6% 17.5%',
  secondaryForeground: '210 40% 98%',
  muted: '217.2 32.6% 17.5%',
  mutedForeground: '215 20.2% 65.1%',
  accent: '217.2 32.6% 17.5%',
  accentForeground: '210 40% 98%',
  destructive: '0 62.8% 30.6%',
  border: '217.2 32.6% 17.5%',
  input: '217.2 32.6% 17.5%',
  ring: '212.7 26.8% 83.9%',
};

const CSS_MAP: Record<string, keyof BrandColorTokens> = {
  '--background': 'background',
  '--foreground': 'foreground',
  '--card': 'card',
  '--card-foreground': 'cardForeground',
  '--primary': 'primary',
  '--primary-foreground': 'primaryForeground',
  '--primary-50': 'primary50',
  '--primary-100': 'primary100',
  '--primary-200': 'primary200',
  '--primary-300': 'primary300',
  '--primary-400': 'primary400',
  '--primary-500': 'primary500',
  '--primary-600': 'primary600',
  '--primary-700': 'primary700',
  '--primary-800': 'primary800',
  '--primary-900': 'primary900',
  '--secondary': 'secondary',
  '--secondary-foreground': 'secondaryForeground',
  '--muted': 'muted',
  '--muted-foreground': 'mutedForeground',
  '--accent': 'accent',
  '--accent-foreground': 'accentForeground',
  '--destructive': 'destructive',
  '--destructive-foreground': 'destructiveForeground',
  '--border': 'border',
  '--input': 'input',
  '--ring': 'ring',
  '--sidebar': 'sidebar',
  '--sidebar-foreground': 'sidebarForeground',
  '--sidebar-active': 'sidebarActive',
  '--sidebar-border': 'sidebarBorder',
  '--radius': 'radius',
};

export function applyBrandThemeToDocument(
  config = resolveBrandConfig(),
  options?: { dark?: boolean },
): void {
  const root = document.documentElement;
  const tokens = options?.dark
    ? { ...config.tokens, ...DARK_SURFACE_OVERRIDES }
    : config.tokens;

  for (const [cssVar, tokenKey] of Object.entries(CSS_MAP)) {
    const value = tokens[tokenKey];
    if (value) {
      root.style.setProperty(cssVar, value);
    }
  }

  root.dataset.brandPreset = config.presetId;
  root.dataset.colorScheme = options?.dark ? 'dark' : 'light';
}

export function getResolvedBrandConfig() {
  return resolveBrandConfig();
}
